import { render, staticRenderFns } from "./ProgramInquiry.vue?vue&type=template&id=5fe204c5"
import script from "./ProgramInquiry.vue?vue&type=script&lang=js"
export * from "./ProgramInquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports